import { t } from 'i18next';
import { object, string, array } from 'yup';

import { SYNONYM_FILTERS } from '../../../../constants';
import { sentenceCase } from '../../../../utils/utils';

export const deploySchema = () =>
  object({
    instanceId: string().required(
      sentenceCase(
        t('selectRequired', {
          ns: 'validations',
          field: t('instance', { ns: 'instance' }),
        })
      )
    ),
    collection: string().required(
      sentenceCase(
        t('selectRequired', {
          ns: 'validations',
          field: t('collection', { ns: 'instance' }),
        })
      )
    ),
    filter: string().required(
      sentenceCase(
        t('selectRequired', {
          ns: 'validations',
          field: t('synonym.filter', { ns: 'fields' }),
        })
      )
    ),
    filename: string().when('filter', {
      is: SYNONYM_FILTERS.SYNONYM_GRAPH_FILTER,
      then: (schema) =>
        schema.required(
          sentenceCase(
            t('inputRequired', {
              ns: 'validations',
              field: t('fileName', { ns: 'fields' }),
            })
          )
        ),
      otherwise: (schema) => schema,
    }),
    resource: string().when('filter', {
      is: SYNONYM_FILTERS.MANAGED_SYNONYM_GRAPH_FILTER,
      then: (schema) =>
        schema.required(
          sentenceCase(
            t('selectRequired', {
              ns: 'validations',
              field: t('synonym.managedResource', { ns: 'fields' }),
            })
          )
        ),
      otherwise: (schema) => schema,
    }),
    initArgs: array().when('filter', {
      is: SYNONYM_FILTERS.MANAGED_SYNONYM_GRAPH_FILTER,
      // This circle validation is to make sure that the user fill in both key and val or neither. Basically a XNOR gate validation
      then: (schema) =>
        schema.of(
          object().shape(
            {
              key: string().when('val', {
                is: (v) => v !== '',
                then: (schema) =>
                  schema.required(t('keyArgsRequired', { ns: 'validations' })),
                otherwise: (schema) => schema,
              }),
              val: string().when('key', {
                is: (v) => v !== '',
                then: (schema) =>
                  schema.required(t('valArgsRequired', { ns: 'validations' })),
                otherwise: (schema) => schema,
              }),
            },
            ['key', 'val']
          )
        ),
    }),
  });
